import type { WorkspaceDto } from '@dbrain/shared';

/**
 * Where a conversation started on the home page goes (web and phone). Only workspaces of this product
 * the person can write in count.
 *  - Chat (v0.15e.2, D-219): their own "Kişisel"; a team workspace only when they pick it. Without a
 *    "Kişisel" (a server before v0.15e.2) the last used one, else the first.
 *  - Code: their pick, else the code workspace used last, else the first (D-152 opens their own when
 *    there is none).
 */
export function homeWorkspace(input: {
  workspaces: readonly WorkspaceDto[];
  experience: 'chat' | 'code';
  /** the workspace of the latest conversation in this product */
  recentWorkspaceId?: string | undefined;
  chosen: string | null;
}): { writable: WorkspaceDto[]; target: WorkspaceDto | undefined } {
  const writable = input.workspaces.filter((w) => w.kind === input.experience && w.role !== 'viewer');
  const picked = writable.find((w) => w.id === input.chosen);
  const own = input.experience === 'chat' ? writable.find((w) => w.personal) : undefined;
  const recent = writable.find((w) => w.id === input.recentWorkspaceId);
  return { writable, target: picked ?? own ?? recent ?? writable[0] };
}
